import { api } from './cliente.js';
import type { TransicaoDisponivel } from './tipos.js';

export type EstadoProjeto = 'Instanciado' | 'Planejado' | 'EmExecucao' | 'Suspenso' | 'Cancelado' | 'Concluido';
export type EstadoFase = 'Pendente' | 'EmAndamento' | 'AguardandoGate' | 'Aprovada';

export interface Projeto {
  id: string;
  demandaId: string;
  blueprintId: string;
  blueprintVersao: number;
  sponsor: string;
  gerente: string;
  estado: EstadoProjeto;
  programaId: string | null;
  beneficioId: string | null;
  baselineVigenteId: string | null;
  criadoPor: string;
  criadoEm: string;
}

export const ESTADOS_PROJETO: EstadoProjeto[] = ['Instanciado', 'Planejado', 'EmExecucao', 'Concluido'];

export interface FaseInstanciada {
  id: string;
  projetoId: string;
  ordem: number;
  nome: string;
  estado: EstadoFase;
  estimadoNaMigracao: boolean;
}

export interface FaseCriterioGate {
  id: string;
  faseId: string;
  descricao: string;
  tipo: string;
  obrigatorio: boolean;
}

export interface FaseArtefato {
  id: string;
  faseId: string;
  nome: string;
  uri: string | null;
  entregueEm: string | null;
  entreguePor: string | null;
}

export interface BaselineProjeto {
  id: string;
  projetoId: string;
  versao: number;
  datasMarcos: { marco: string; dataBaseline: string }[];
  esforcoPorFase: { faseOrdem: number; horasBaseline: number }[];
  origem: string;
  aprovadaPor: string;
  aprovadaEm: string;
}

export interface AvaliacaoCriterio {
  criterioId: string;
  atendido: boolean;
  evidencia?: string;
}

export interface LinhaGantt {
  faseId: string;
  faseNome: string;
  grupo: string | null;
  atividadeId: string;
  atividadeNome: string;
  inicioPrevisto: string | null;
  fimPrevisto: string | null;
  estado: string;
  pctDerivado: number;
  predecessoraId: string | null;
  conflito: boolean;
}

export const projetosApi = {
  listar: () => api.get<Projeto[]>('/projetos'),
  buscar: (id: string) => api.get<Projeto>(`/projetos/${id}`),
  fases: (id: string) => api.get<FaseInstanciada[]>(`/projetos/${id}/fases`),
  baselines: (id: string) => api.get<BaselineProjeto[]>(`/projetos/${id}/baselines`),
  aprovarBaseline: (id: string, datasMarcos: { marco: string; dataBaseline: string }[], esforcoPorFase: { faseOrdem: number; horasBaseline: number }[]) =>
    api.post<{ id: string }>(`/projetos/${id}/baseline`, { datasMarcos, esforcoPorFase }),
  transicoesDisponiveis: (id: string) => api.get<TransicaoDisponivel[]>(`/projetos/${id}/transicoes`),
  transicionar: (id: string, evento: string, justificativa?: string) => api.post(`/projetos/${id}/transicoes`, { evento, justificativa }),
  submeterAoGate: (faseId: string) => api.post(`/fases/${faseId}/submeter-gate`),
  transicoesFase: (faseId: string) => api.get<TransicaoDisponivel[]>(`/fases/${faseId}/transicoes`),
  criteriosGate: (faseId: string) => api.get<FaseCriterioGate[]>(`/fases/${faseId}/criterios`),
  artefatos: (faseId: string) => api.get<FaseArtefato[]>(`/fases/${faseId}/artefatos`),
  entregarArtefato: (faseId: string, nome: string, uri: string) => api.post(`/fases/${faseId}/artefatos`, { nome, uri }),
  avaliarGate: (faseId: string, criterios: AvaliacaoCriterio[], resultado: 'Aprovado' | 'Reprovado', justificativa?: string) =>
    api.post<{ id: string }>(`/fases/${faseId}/gate`, { criterios, resultado, justificativa }),
  gantt: (id: string) => api.get<LinhaGantt[]>(`/projetos/${id}/gantt`),
};
